import 'slick-carousel';
import 'slick-lightbox';

export default {
  init() {
    // JavaScript to be fired on all pages
      $('.gallery').slick({
        // lazyLoad: 'ondemand',
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        //adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },    
        ]
      });

      $('.gallery').slickLightbox({
            src: 'src',
            itemSelector: '.image img',
            captionPosition:'bottom',
            caption: function(element, info) {               
              return $(element).siblings('img:first').attr('data-caption');
            }            
          
      });

      $('.singlegallery').slick({
          // lazyLoad: 'ondemand',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          adaptiveHeight: true,  //Ankita shah : uncomment this line        
      });

      $('.singlegallery').slickLightbox({
          src: 'src',
          itemSelector: '.image img',
      });

      $('.gallery-box').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          infinite: true,
          asNavFor: '.galleryproducer',
      });
      $('.galleryproducer').slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          asNavFor: '.gallery-box',
          dots: false,
          centerMode: true,
          focusOnSelect: true,
          infinite: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },    
          ]
      });
      $('.galleryproducersingle').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.gallery-box-single',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
      })
      $('.gallery-box-single').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: true,
        asNavFor: '.galleryproducersingle',
    });


    $('.gallery_menu').on('init', function(event, slick){     
        var current_slider = jQuery(this);
        current_slider.find('.slick-active:first').addClass('slick-first');
        current_slider.find('.slick-active:last').addClass('slick-last');
    });
  
    $('.gallery_menu').slick({
      // lazyLoad: 'ondemand',
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },    
      ]
    });

    $('.gallery_menu').on('afterChange', function(event, slick, currentSlide, nextSlide){         
      var current_slider = $(this);
      current_slider.find('.slick-slide').removeClass('slick-last');   
      current_slider.find('.slick-slide').removeClass('slick-first');  
      current_slider.find('.slick-active:first').addClass('slick-first');
      current_slider.find('.slick-active:last').addClass('slick-last');
  });

  // $('.slick-slide').mouseover(function(){
  //   // var prev_slide = $(this).prevAll();
  //   // var next_slide = $(this).nextAll();
  //   // prev_slide.toggleClass('shift-left');
  //   // next_slide.toggleClass('shift-right');
  //   $(this).prev().addClass('prevSlide');
  //   $(this).next().addClass('nextSlide');
  // });

  $('.gallery_menu').on('mouseenter', '.slick-slide', function (e) {
    var $currTarget = $(e.currentTarget);
    console.log($currTarget)
    $('.slider-nav .slick-slide').removeClass('slick-current');
    $currTarget.addClass('slick-current');
    $(this).prevAll().addClass('shift-left');
    $(this).nextAll().addClass('shift-right');
    //$currTarget.removeClass('slick-last');
  }).on('mouseleave', '.slick-slide', function (e) {
       $('.gallery_menu .slick-slide').removeClass('shift-left');
       $('.gallery_menu .slick-slide').removeClass('shift-right');
       $('.gallery_menu .slick-slide').removeClass('slick-current');
  }); 

  // ZOOM
  $(function() {
    $('.ex1').zoom();
  

    // STYLE GRAB
    $('.ex2').zoom({ on:'grab' });


    // STYLE CLICK
    $('.ex3').zoom({ on:'click' });	

    // STYLE TOGGLE
    $('.ex4').zoom({ on:'toggle' });

  });
  
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },

};




// WEBPACK FOOTER //
// ./scripts/routes/common.js